import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { WelletContext } from '../../context/WelletContext';
import { useDispatch, useSelector } from 'react-redux';
import { errorText } from '../../helpers/login';
import { useTranslation } from 'react-i18next';
import { setCanRefresh } from '../../actions/appActions';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import Button from '../../components/Common/Button/Button';
import useForm from '../../helpers/useForm';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import { Spinner } from '../../components/Common/Spinner/Spinner';
import 'react-phone-number-input/style.css';
import styles from './SignUp.module.css';
import IndustryRoleSelectorRosaNegra from '../../components/Common/IndustryRoleSlector/IndustryRoleSelectorRosaNegra';
import FileUpload from '../../components/FileUpload/ImageUpload ';
import { Head } from 'react-day-picker';

const RevalidationInfoSceen = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const welletContext = useContext(WelletContext);
  const dispatch = useDispatch();
  const [worked, setWorked] = useState(null);
  const [familyWorked, setFamilyWorked] = useState(null);
  const [verifyingUser, setVerifyingUser] = useState(false);
  const [errorUser, setErrorUser] = useState(undefined);
  const [selectedIndustry, setSelectedIndustry] = useState(t('signUp.selectSector'));
  const [selectedRp, setSelectedRp] = useState({ label: t('signUp.selectRp') });
  const [selectedCity, setSelectedCity] = useState({ label: t('signUp.selectCity') });
  const hasNoRp = selectedRp.value === '0';
const [selectedFiles, setSelectedFiles] = useState([]);
  const requiresRP = useSelector((state) => state.app?.currentMarket?.requiresRP);
  useEffect(() => {
    dispatch(setCanRefresh(false));
  }, []);
  const handleFileSelect = (files) => {
    setSelectedFiles(files);
  };
  function validate(values) {
    let errors = {};

    if (!values.industry || values.industry === t('selectSector')) {
      errors.industry = t('errorSignUp.NO_INDUSTRY');
    }
    if (!values.role) {
      errors.role = t('errorSignUp.NO_ROLE');
    }
    if (!values.company) {
      errors.company = t('errorSignUp.NO_COMPANY');
    }

    if (values.industry === 'Hotel') {
      if (!values.corporateEmail) {
        errors.corporateEmail = t('errorSignUp.NO_CORPORATE_EMAIL');
      }
    } else {
      if (values.industry && !values.socialNetworkCompany) {
        errors.socialNetworkCompany = t('errorSignUp.NO_SOCIAL_NETWORK');
      }

      if (values.industry && !values.officeAddressCompany) {
        errors.officeAddressCompany = t('errorSignUp.NO_OFFICE_ADDRESS');
      }

      if (values.industry && !values.webCompany) {
        errors.webCompany = t('errorSignUp.NO_WEB');
      }
    }

    if (requiresRP) {
      if (!values.rp) errors.rp = t('selectRP');

      if (hasNoRp && !values.city) errors.city = t('selectCity');
    }

    if (!selectedFiles || selectedFiles.length === 0) {
      errors.file = t('uploadPhoto');
    }

    return errors;
  }

  const filesToBase64 = (files) => {
    return Promise.all(
      files.map(
        (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = (error) => reject(error);
          }),
      ),
    );
  };

  const sendForm = async () => {
    setVerifyingUser(true);
    try {
      const payload = {
        CorporateEmail: values.corporateEmail,
        Company: values.company,
        officeAddressCompany: values.officeAddressCompany || null,
        socialNetworkCompany: values.socialNetworkCompany || null,
        webCompany: values.webCompany || null,
        sector: values.industry,
        jobtitle: values.role,
        HasWorkedPreviously: worked,
        HasFamilyWorking: familyWorked,
        ...(requiresRP && { RpId: values.rp === '0' ? null : values.rp, CityId: values.city }),
      };

      if (selectedFiles.length > 0) {
        const workCredentialsBase64 = await filesToBase64(selectedFiles);
        payload.workCredential = workCredentialsBase64;
      }

      const result = await welletContext.apis.tickets.put('users/data', payload);

      if (result.data.isAvailable) {
        errorText(result.data.availableMessage, setErrorUser, t);
      } else {
        const { workCredential, ...queryPayload } = payload;
        const queryParams = new URLSearchParams(queryPayload).toString();

        history.push({
          pathname: '/kyc-start',
          search: `?${queryParams}`,
        });
      }

      setVerifyingUser(false);
    } catch (error) {
      console.error(error);
      setVerifyingUser(false);
    }
  };

  const onChange = (e) => {
    setErrorUser('');
    handleChange(e);
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <>
      <Header showBack={false} />
      <ContentApp>
        <>
          <div className=' bold text-white mt-3'>{t('revalidationData')}</div>
          <div className='mt-1  text-secondary font-tiny '>{t('pleaseRevalidationProcess')}</div>
          <form onSubmit={handleSubmit}>
            <div className='mt-4'>
              <IndustryRoleSelectorRosaNegra
                handleChange={onChange}
                selectedIndustry={selectedIndustry}
                setSelectedIndustry={setSelectedIndustry}
                selectedRp={selectedRp}
                setSelectedRp={setSelectedRp}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                values={values}
                errors={errors}
                requiresRP={requiresRP}
              />
            </div>
            {errorUser && (
              <div className='mt-5'>
                <ErrorBox title={errorUser} />
              </div>
            )}
            <div className='mt-4'>
              <FileUpload onFileSelect={handleFileSelect} />
              {errors.file && (
                <div className='errorLabel position-relative mt-2'>{errors.file}</div>
              )}
            </div>

            <div className='row mt-4'>
              <div className='col my-auto'>
                <div className='semi-bold'>{t('signUp.workedBefore')}</div>
              </div>
              <div className='col-auto'>
                <div className={styles.toggleButtons}>
                  <button
                    type='button'
                    className={`btn ${worked === true ? 'btn-primary' : 'btn-secondary'}`}
                    onClick={() => setWorked(true)}
                  >
                    {t('yes')}
                  </button>
                  <button
                    type='button'
                    className={`btn ${worked === false ? 'btn-primary' : 'btn-secondary'}`}
                    onClick={() => setWorked(false)}
                  >
                    {t('No')}
                  </button>
                </div>
              </div>
              {errors.worked && (
                <div className='col-12'>
                  <div className='errorLabel position-relative mt-2'>{errors.worked}</div>
                </div>
              )}
            </div>

            <div className='row mt-4'>
              <div className='col my-auto'>
                <div className='semi-bold'>{t('signUp.familyWorked')}</div>
              </div>
              <div className='col-auto'>
                <div className={styles.toggleButtons}>
                  <button
                    type='button'
                    className={`btn ${familyWorked === true ? 'btn-primary' : 'btn-secondary'}`}
                    onClick={() => setFamilyWorked(true)}
                  >
                    {t('yes')}
                  </button>
                  <button
                    type='button'
                    className={`btn ${familyWorked === false ? 'btn-primary' : 'btn-secondary'}`}
                    onClick={() => setFamilyWorked(false)}
                  >
                    {t('No')}
                  </button>
                </div>
              </div>
              {errors.familyWorked && (
                <div className='col-12'>
                  <div className='errorLabel position-relative mt-2'>{errors.familyWorked}</div>
                </div>
              )}
            </div>

            <div className='mt-4 font-tiny text-secondary'>{t('signUp.confirmText')}</div>
            <div className='mt-4'>
              <Button
                size='large'
                fontSize={'18px'}
                text={
                  verifyingUser ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('continue')
                  )
                }
                icon={verifyingUser ? false : true}
                typeIcon='arrow'
                iconColor='#000'
                type='submit'
              />
            </div>
          </form>
        </>
      </ContentApp>
    </>
  );
};

export default RevalidationInfoSceen;
